import Api from "@/api/api";

const SupportService = {
    getLiveChatApp() {
        return Api().get(`/support/livechat/app`);
    },
    getTicketTopics() {
        return Api().get(`/support/ticket/topicList`);
    },
};

export default SupportService;